import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { SubmissionConstants } from '../models/constants/submissions-constants';

export function facilityValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const errMessage = new SubmissionConstants().adminRequiredFieldError;
    const value: string = control.value;

    // TODO: implement validation logic
    if (!value) {
      return { facilityInvalid: errMessage };
    }
    const nameSection = value.substring(0, value.indexOf('('));
    const numberSection = value.substring(
      value.indexOf('(') + 1,
      value.indexOf(')'),
    );
    if (nameSection.trim().length === 0 || numberSection.trim().length === 0) {
      return { facilityInvalid: errMessage };
    }
    return null;
  };
}
